import ApiService from '../services/api';
import TYPES from './actionTypes';
import { getStorage } from '../services/utils';
import { setSentryUser } from '../utils/sentry';

export function getUserAccount() {
  return async dispatch => {
    const apiKey = getStorage('apiKey');

    if (!apiKey) {
      return Promise.reject('No api key');
    }

    const resp = await ApiService.get('/api/customer/account', true);
    dispatch({ type: TYPES.GET_USER_ACCOUNT, data: resp });
    return Promise.resolve(resp);
  };
}

export function closeLoginDialog() {
  return async dispatch => {
    dispatch({ type: TYPES.TOGGLE_LOGIN_DIALOG, data: false });
  };
}

export const loginSuccess = user => {
  return dispatch => {
    // Existing login logic...
    setSentryUser(user);
    dispatch({ type: TYPES.LOGIN_SUCCESS, payload: user });
  };
};

export const logout = () => {
  return dispatch => {
    // Existing logout logic...
    setSentryUser(null);
    dispatch({ type: TYPES.LOGOUT });
  };
};
